import { authHttp } from '../http'
import * as routes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveMissingReason({
  id,
  company_id,
  sigla,
  descricao,
  type,
  visible_picking,
  visible_delivery,
  actived,
  devolucao_fisica,
  company_code,
}) {
  try {
    const payload = {
      company_id,
      sigla,
      descricao,
      type,
      visible_picking,
      visible_delivery,
      actived,
      devolucao_fisica,
      company_code: company_code && company_code.trim() ? company_code : null,
    }

    let response
    if (id) {
      response = await authHttp().put(routes.urlPostPutMissingReasons, {
        id,
        ...payload,
      })
    } else {
      response = await authHttp().post(routes.urlPostPutMissingReasons, payload)
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getMissingReasons(company_id) {
  try {
    const response = await authHttp().get(routes.urlGetMissingReasons(company_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
